import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useWalletQueryParams({ setActiveTab, setShowRechargeModal }) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tab = searchParams.get('tab');
    const action = searchParams.get('action');

    if (tab === 'meta-wallet' || tab === 'meta') {
      setActiveTab('meta-wallet');
    }

    if (action === 'recharge') {
      setShowRechargeModal(true);
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('action');
      setSearchParams(nextParams, { replace: true });
    }
  }, [searchParams, setActiveTab, setShowRechargeModal, setSearchParams]);
}
